import { useQueryStates, parseAsIndex, parseAsInteger } from 'nuqs'

type UsePaginationQueryStateOptions = {
  defaultPageSize?: number
  // 'index' stores a 1-indexed page number in the URL (e.g. ?page=1 for the first page).
  // 'integer' stores the raw 0-indexed pageIndex in the URL (e.g. ?page=0 for the first page).
  pageIndexParser?: 'index' | 'integer'
  urlKeys?: { pageIndex: string; pageSize: string }
}

export const usePaginationQueryState = (
  options: UsePaginationQueryStateOptions = {}
) => {
  const {
    defaultPageSize = 50,
    pageIndexParser = 'index',
    urlKeys = { pageIndex: 'page', pageSize: 'page-size' },
  } = options

  const pageIndexParserImpl =
    pageIndexParser === 'index' ? parseAsIndex : parseAsInteger

  const queryStates = useQueryStates(
    {
      pageIndex: pageIndexParserImpl.withDefault(0),
      pageSize: parseAsInteger.withDefault(defaultPageSize),
    },
    {
      urlKeys,
    }
  )

  return queryStates
}
